import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { DefaultCollectContext } from '../..';

export const ModalAcceptInvoiceNotIssued = () => {
  const { setAcceptedInvoiceNotIssued } = useContext(DefaultCollectContext);

  const { Modal, closeModal } = useModal();

  const handleAcceptTerms = () => {
    setAcceptedInvoiceNotIssued(true);
    closeModal();
  };

  return (
    <Modal preventClose>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}
      >
        <ModalTitle>Atenção</ModalTitle>

        <ModalText>
          Se faz necessário a nota fiscal ser entregue no momento da coleta.
          <br />
          Caso não ocorra a entrega, o motorista não realizará a coleta.
        </ModalText>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32,
            marginTop: 16
          }}
        >
          <Button
            type="button"
            data-testid="okAcceptInvoiceNotIssuedModalButton"
            variant="contained"
            onClick={handleAcceptTerms}
          >
            Ok
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
